import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {paginator, WeavePaginationComponent} from "../../../shared/weave-pagination/weave-pagination.component";

@Component({
    selector: 'app-side-nav-pane',
    templateUrl: './side-nav-pane.component.html',
    styleUrls: ['./side-nav-pane.component.scss'],
    standalone: false
})
export class SideNavPaneComponent implements OnInit {

  @Input() list: sidenavListItem[] = [];
  @Input() title: string = '';
  @Input() filterTitle: string = '';
  @Input() tableTitle: string = '';
  searchQuery: string = '';
  isClosed: boolean = true;
  allItems: sidenavListItem[] = [];
  currentPageItems: sidenavListItem[] = [];
  pager: paginator = { ...WeavePaginationComponent.DEFAULT_PAGINATOR };
  @ViewChild("paginator") paginatorComponent: WeavePaginationComponent;

  constructor() { }

  ngOnInit(): void {
    //sort list
    this.allItems = JSON.parse(JSON.stringify(this.list));
    this.allItems.sort((a, b) => a.name.localeCompare(b.name));
    setTimeout(() => {
      this.isClosed = false;
    }, 0);
    this.pager.totalItems = this.allItems.length;
    this.setCurrentPageItems();
  }

  setCurrentPageItems() {
    if(this.searchQuery === '') {
      this.currentPageItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex);
    }
    else{
      this.currentPageItems = this.allItems.filter(item => item.name.toLowerCase().includes(this.searchQuery.toLowerCase())).slice(this.pager.startIndex, this.pager.endIndex);
    }
  }

  setPagerOfficial(pager: paginator) {
    if(JSON.stringify(this.pager) !== JSON.stringify(pager)) {
      this.pager = pager;
      this.setCurrentPageItems();
    }
  }

  closeSideNavPan() {
    this.isClosed = true;
  }

  resetPagination() {
    if(this.paginatorComponent) {
      this.paginatorComponent.resetPager( this.pager );
    }
  }

}

export interface sidenavListItem{
  name: string;
  routerLink: string;
  queryParams: any;
}
